module.exports = __webpack_public_path__ + "img/ercode_nx.282461d7.png";